import React from 'react';
import { motion } from 'framer-motion';
import { Star, MessageCircle } from 'lucide-react';
const testimonials = [{
  initial: 'V',
  color: 'bg-pink-100 text-pink-700',
  name: 'Valeria M.',
  location: 'Psicóloga — Buenos Aires',
  text: 'Tenía los consentimientos firmados de algunos pacientes y de otros no. Con el pack los imprimí todos, los hice firmar en la siguiente sesión y por primera vez siento que estoy realmente cubierta. Una tranquilidad enorme.'
}, {
  initial: 'M',
  color: 'bg-blue-100 text-blue-700',
  name: 'Matías R.',
  location: 'Psicólogo — Córdoba',
  text: 'El sistema de cobros me cambió la vida. Tenía pacientes que me debían hace meses y ni sabía cuánto exactamente. Ahora cierro cada mes con todo al día.'
}, {
  initial: 'L',
  color: 'bg-emerald-100 text-emerald-700',
  name: 'Laura T.',
  location: 'Psicóloga — Rosario',
  text: 'La guía de ARCA sola ya valió todo. Por fin entendí cómo recategorizar, qué gastos puedo deducir y cómo emitir facturas a las obras sociales sin errores.'
}, {
  initial: 'F',
  color: 'bg-amber-100 text-amber-700',
  name: 'Federico B.',
  location: 'Psicólogo — Mendoza',
  text: 'Los guiones de WhatsApp me salvaron. Siempre me costó muchísimo cobrar sin incomodarme. Ahora mando el mensaje y listo. Sin culpa y sin vueltas.'
}];
export function TestimonialsBottom() {
  return <section className="py-12 md:py-16 bg-transparent" data-id="element-194">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-195">
        <div className="text-center mb-12 flex flex-col items-center" data-id="element-196">
          <MessageCircle className="w-10 h-10 text-[#d4a017] mb-4" data-id="element-197" />
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-[#2f3a2c]" data-id="element-198">
            Lo que otros psicólogos están diciendo
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-199">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl p-8 shadow-sm border border-slate-200 flex flex-col h-full" data-id="element-200">
              <div className="flex text-[#d4a017] mb-4" data-id="element-201">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-202" />)}
              </div>

              <p className="text-slate-700 text-lg leading-relaxed mb-6 italic flex-grow" data-id="element-203">
                "{t.text}"
              </p>

              <div className="flex items-center border-t border-slate-100 pt-4 mt-auto" data-id="element-204">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold ${t.color} mr-3 flex-shrink-0`} data-id="element-205">
                  {t.initial}
                </div>
                <div data-id="element-206">
                  <div className="font-bold text-[#2f3a2c] text-sm" data-id="element-207">
                    {t.name}
                  </div>
                  <div className="text-xs text-slate-500" data-id="element-208">{t.location}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}